import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['inputSection'];

  connect() {
  }

  scroll() {
    this.inputSectionTarget.scrollIntoView({block: 'center'});
  }

}
